var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZoomIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6676 2.68366C13.0342 2.68566 13.3309 2.98299 13.3309 3.34966L13.3329 6.66633C13.3336 7.03433 13.0349 7.33366 12.6669 7.33366H12.6662C12.2982 7.33366 12.0002 7.03499 11.9996 6.66766L11.9982 4.94433L9.80425 7.13833C9.67425 7.26833 9.50358 7.33366 9.33291 7.33366C9.16291 7.33366 8.99225 7.26833 8.86158 7.13833C8.60158 6.87766 8.60158 6.45566 8.86158 6.19566L11.0482 4.00899L9.33025 4.00033C8.96158 3.99833 8.66425 3.69766 8.66625 3.33033C8.66825 2.96299 8.96691 2.66699 9.33291 2.66699H9.33625L12.6676 2.68366ZM6.19518 8.86206C6.45585 8.60139 6.87718 8.60139 7.13785 8.86206C7.39851 9.12273 7.39851 9.54406 7.13785 9.80473L4.94318 11.9994L6.66651 12.0001C7.03518 12.0001 7.33318 12.2987 7.33318 12.6674C7.33251 13.0354 7.03451 13.3334 6.66651 13.3334H6.66585L3.34918 13.3314C2.98251 13.3314 2.68518 13.0347 2.68318 12.6681L2.66651 9.33673C2.66451 8.96873 2.96185 8.66873 3.32985 8.66673H3.33318C3.69985 8.66673 3.99785 8.96273 3.99985 9.33006L4.00851 11.0487L6.19518 8.86206Z",
    fill: "#8D96B2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomIn);
export default __webpack_public_path__ + "static/media/ZoomIn.93f56bffd475a39f286eb8aa06aaca1a.svg";
export { ForwardRef as ReactComponent };